import { render, staticRenderFns } from "./MenuDrawer.vue?vue&type=template&id=22506950&scoped=true"
import script from "./MenuDrawer.vue?vue&type=script&lang=js"
export * from "./MenuDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22506950",
  null
  
)

export default component.exports